import { getPortalServerIp } from '../storage';
import api from './apiPortal';
import { IdentificationId } from './util';
import { DecryptMessage, RsaDecryptor } from '../services/e2ee';
import { getE2EEncryptionEnabledFlag } from '../storage/index';

import {
  getDecryptedConversationKeyFromCache,
  setDecryptedConversationKeyCache,
} from './conversationKeyCache';

// const serverUrl = getPortalServerIp();

// const GetConversations = async () => {
//   try {
//     if (getPortalServerIp() !== 'https://null') {
//       api.defaults.baseURL = getPortalServerIp();
//       let data = {};
//       data = IdentificationId();
//       data.conversationFilter = 1;
//       return api
//         .post('/PortalStaff/ios/GetConversations', data)
//         .then((res) => res.data);
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

const GetConversations = async () => {
  const isE2EEnabled = getE2EEncryptionEnabledFlag();
  const portalServerIp = getPortalServerIp();

  if (portalServerIp === 'https://null') {
    return [];
  }

  try {
    api.defaults.baseURL = portalServerIp;

    const data = IdentificationId();
    data.conversationFilter = 1;

    const response = await api.post('/PortalStaff/ios/GetConversations', data);
    const conversations = response.data.conversations || [];

    if (!isE2EEnabled) {
      return response.data;
    }

    const decryptedKeys = [];
    const decryptedIVs = [];
    let hasCheckedOne = false; // Flag to force bypass cache once to verify key validity

    for (const conversation of conversations) {
      let decryptedAESKey = null;
      let decryptedAESIV = null;

      try {
        // Bypass cache for the first key to verify private key validity
        const cached = hasCheckedOne
          ? getDecryptedConversationKeyFromCache(conversation.Guid)
          : null;

        if (!cached) {
          if (conversation.EncryptionKey && conversation.Iv) {
            decryptedAESKey = await RsaDecryptor(conversation.EncryptionKey);
            decryptedAESIV = await RsaDecryptor(conversation.Iv);
            setDecryptedConversationKeyCache(
              conversation.Guid,
              decryptedAESKey,
              decryptedAESIV
            );
            hasCheckedOne = true; // Key validity checked successfully
          }
        } else {
          decryptedAESKey = cached.key;
          decryptedAESIV = cached.iv;
        }

        // if (conversation.EncryptionKey && conversation.Iv) {
        //   decryptedAESKey = await RsaDecryptor(conversation.EncryptionKey);
        //   decryptedAESIV = await RsaDecryptor(conversation.Iv);
        // }

        decryptedKeys.push({ Guid: conversation.Guid, Key: decryptedAESKey });
        decryptedIVs.push({ Guid: conversation.Guid, IV: decryptedAESIV });

        if (conversation.LastMessage?.Message) {
          conversation.LastMessage.Message = await DecryptMessage(
            conversation.LastMessage.Message,
            decryptedAESIV,
            decryptedAESKey
          );
        } else if (
          conversation.LastMessage?.ReferencedMessage?.Message &&
          conversation.LastMessage.IsForward
        ) {
          conversation.LastMessage.ReferencedMessage.Message =
            await DecryptMessage(
              conversation.LastMessage.ReferencedMessage.Message,
              decryptedAESIV,
              decryptedAESKey
            );
        }
      } catch (decryptionError) {
        console.error(
          `Decryption failed for conversation ${conversation.Guid}`,
          decryptionError
        );
        // Dispatch the logout event so the UI displays the alert popup
        window.dispatchEvent(new Event('force-logout'));
        break; // Exit the loop since the key is invalid
      }
    }

    return {
      ...response.data,
      conversations,
      decryptedKeys,
      decryptedIVs,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// const GetConversationsArchive = async () => {
//   try {
//     if (getPortalServerIp() !== 'https://null') {
//       api.defaults.baseURL = getPortalServerIp();
//       let data = {};
//       data = IdentificationId();
//       data.conversationFilter = 2;
//       const response = await api
//         .post('/PortalStaff/ios/GetConversations', data)
//         .then((res) => res.data);
//       return response;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };

const GetConversationsArchive = async () => {
  const isE2EEnabled = getE2EEncryptionEnabledFlag();
  const portalServerIp = getPortalServerIp();

  if (portalServerIp === 'https://null') {
    return [];
  }

  try {
    api.defaults.baseURL = portalServerIp;

    const data = IdentificationId();
    data.conversationFilter = 2;

    const response = await api.post('/PortalStaff/ios/GetConversations', data);
    const conversations = response.data.conversations || [];

    if (!isE2EEnabled) {
      return response.data;
    }

    const decryptedKeys = [];
    const decryptedIVs = [];

    for (const conversation of conversations) {
      let decryptedAESKey = null;
      let decryptedAESIV = null;

      try {
        if (conversation.EncryptionKey && conversation.Iv) {
          decryptedAESKey = await RsaDecryptor(conversation.EncryptionKey);
          decryptedAESIV = await RsaDecryptor(conversation.Iv);
        }

        decryptedKeys.push({ Guid: conversation.Guid, Key: decryptedAESKey });
        decryptedIVs.push({ Guid: conversation.Guid, IV: decryptedAESIV });

        if (conversation.LastMessage?.Message) {
          conversation.LastMessage.Message = await DecryptMessage(
            conversation.LastMessage.Message,
            decryptedAESIV,
            decryptedAESKey
          );
        }
      } catch (decryptionError) {
        console.error(
          `Decryption failed for conversation ${conversation.Guid}`,
          decryptionError
        );
        throw decryptionError;
      }
    }

    return {
      ...response.data,
      conversations,
      decryptedKeys,
      decryptedIVs,
    };
  } catch (error) {
    console.error(error);
    return [];
  }
};

// const GetMessagesForConversations = async ({
//   Guid,
//   indexMessageGuid = '',
//   maxNumberMessages = -1,
// }) => {
//   if (getPortalServerIp() !== 'https://null') {
//     api.defaults.baseURL = getPortalServerIp();
//     let identificationId = IdentificationId();
//     identificationId.conversationGuid = Guid;
//     identificationId.indexMessageGuid = indexMessageGuid;
//     identificationId.maxNumberMessages = maxNumberMessages;
//     // console.log(identificationId);
//     return api
//       .post('/PortalStaff/ios/GetMessagesForConversation', identificationId)
//       .then((res) => res.data);
//   } else {
//     return [];
//   }
// };

const decryptReferencedMessageRecursive = async (
  referencedMessage,
  key,
  iv
) => {
  if (!referencedMessage) return;

  if (referencedMessage.Message) {
    referencedMessage.Message = await DecryptMessageForConversation(
      referencedMessage.Message,
      key,
      iv
    );
  }

  if (referencedMessage.ReferencedMessage) {
    await decryptReferencedMessageRecursive(
      referencedMessage.ReferencedMessage,
      key,
      iv
    );
  }
};

const GetMessagesForConversations = async ({
  Guid,
  indexMessageGuid = '',
  maxNumberMessages = -1,
  conversationDecryptedKey,
  conversationDecryptedIV,
}) => {
  if (getPortalServerIp() === 'https://null') return [];

  api.defaults.baseURL = getPortalServerIp();
  let identificationId = IdentificationId();
  identificationId.conversationGuid = Guid;
  identificationId.indexMessageGuid = indexMessageGuid;
  identificationId.maxNumberMessages = maxNumberMessages;

  const res = await api.post(
    '/PortalStaff/ios/GetMessagesForConversation',
    identificationId
  );
  const data = res.data;

  // Only decrypt if E2E encryption is enabled
  if (data.GetMessagesForConversationResult) {
    const key = conversationDecryptedKey?.find((item) => item.Guid === Guid);
    const iv = conversationDecryptedIV?.find((item) => item.Guid === Guid);

    if (key && iv) {
      data.orderedMessages = await Promise.all(
        data.orderedMessages.map(async (message) => {
          message.Message = await DecryptMessageForConversation(
            message.Message,
            key,
            iv
          );

          if (message.ReferencedMessage) {
            await decryptReferencedMessageRecursive(
              message.ReferencedMessage,
              key,
              iv
            );
          }

          return message;
        })
      );
    }
    return data;
  } else {
    return [];
  }
};

const DecryptMessageForConversation = async (message, keyObj, ivObj) => {
  try {
    if (!keyObj.Key || !ivObj.IV) return message;
    const data = await DecryptMessage(message, ivObj.IV, keyObj.Key);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetOrCreateConversationByContactInformation = async ({
  contactInformation,
}) => {
  api.defaults.baseURL = getPortalServerIp();
  let body = {};
  try {
    body = IdentificationId();
    body.contactInformation = contactInformation;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/GetOrCreateConversationByContactInformation', body)
    .then((res) => res.data);
};

const CreateManualStaffGroup = async ({ name, priority, privateGroup }) => {
  let body = {};
  api.defaults.baseURL = getPortalServerIp();
  try {
    body = IdentificationId();
    body.name = name;
    body.priority = priority;
    body.privateGroup = privateGroup;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/CreateManualStaffGroup', body)
    .then((res) => res.data);
};

const AddMembersToManualStaffGroup = async ({
  staffGroup,
  toBeIncludedMembers,
}) => {
  api.defaults.baseURL = getPortalServerIp();
  let body = {};
  try {
    body = IdentificationId();
    body.staffGroup = staffGroup;
    body.toBeIncludedMembers = toBeIncludedMembers;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/AddMembersToManualStaffGroup_V1', body)
    .then((res) => res.data);
};

const RemoveMembersFromManualStaffGroup = async ({
  staffGroup,
  toBeExcludedMembers,
}) => {
  api.defaults.baseURL = getPortalServerIp();
  let body = {};
  try {
    body = IdentificationId();
    body.staffGroup = staffGroup;
    body.toBeExcludedMembers = toBeExcludedMembers;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/RemoveMembersFromManualStaffGroup_V1', body)
    .then((res) => res.data);
};

const DeleteConversation = async ({ Guid }) => {
  api.defaults.baseURL = getPortalServerIp();
  let body = {};
  try {
    body = IdentificationId();
    body.conversation = { Guid };
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/DeleteConversation', body)
    .then((res) => res.data);
};

const DeleteManualStaffGroup = async ({ staffGroup }) => {
  let body = {};
  api.defaults.baseURL = getPortalServerIp();
  try {
    body = IdentificationId();
    body.staffGroup = staffGroup;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/DeleteManualStaffGroup_V1', body)
    .then((res) => res.data);
};

const setConversationState = async ({ Guid }, isArchive) => {
  let body = {};
  api.defaults.baseURL = getPortalServerIp();
  try {
    body = IdentificationId();
    body.conversation = Guid;
    body.isArchived = isArchive;
  } catch (error) {
    console.log(error);
  }
  return api
    .post('/PortalStaff/ios/SetConversationState', body)
    .then((res) => console.log(res.data));
};

const setCallStatus = async (callerID) => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = serverUrl; // development

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      data.callGuid = callerID;
      data.videoEnabled = false;
      // console
      console.log(data);
      return api
        .post('/portalcall/ios/setvideostatus', data)
        .then((res) => res.data);
      // .then((res) => console.log(res))
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const getCallEvent = async () => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging
      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      data.maxTimeOutSeconds = 10;
      // console
      // console.log(data);
      return api
        .post('/portalcall/ios/GetCallEvent', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const GetCallStatus = async (callGuid) => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      data.callGuid = callGuid;
      data.maxTimeOutSeconds = 0;
      // console
      // console.log(data);
      return api
        .post('/portalcall/ios/getcallstatus', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const StartCallUsingContactInformation = async (staffGuid, identityType) => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      let identityInformationData = {
        IdentityGuid: staffGuid, // staffGuid
        IdentityType: identityType, //1 (for staffmember), 3 (for staffmembergroup)
      };

      data.identityInformation = identityInformationData;
      data.priority = 0;
      return api
        .post('/portalcall/ios/StartCallUsingContactInformation', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const GetCallInformationUsingCallGuid = async (callGuid) => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      data.callGuid = callGuid;
      return api
        .post('/portalcall/ios/GetCallInformationUsingCallGuid', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const callDisconnectUsingGuid = async (callGuid) => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      data.callGuid = callGuid;
      return api
        .post('/portalcall/ios/CallCancelled', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

const GetCallHistory = async () => {
  try {
    if (getPortalServerIp() !== 'https://null') {
      // api.defaults.baseURL = 'https://portal-test.squre.io'; // production
      // api.defaults.baseURL = 'https://squre-stage.squre.io'; // staging

      api.defaults.baseURL = getPortalServerIp();
      let data = {};
      data = IdentificationId();
      // data.callGuid = callGuid;
      return api
        .post('/portalcall/ios/GetCallHistory', data)
        .then((res) => res.data);
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
  }
};

export {
  GetConversations,
  GetConversationsArchive,
  GetMessagesForConversations,
  GetOrCreateConversationByContactInformation,
  CreateManualStaffGroup,
  DeleteManualStaffGroup,
  AddMembersToManualStaffGroup,
  RemoveMembersFromManualStaffGroup,
  DeleteConversation,
  setConversationState,
  setCallStatus,
  getCallEvent,
  GetCallStatus,
  StartCallUsingContactInformation,
  GetCallInformationUsingCallGuid,
  callDisconnectUsingGuid,
  GetCallHistory,
  DecryptMessageForConversation,
};
